import { getTimezoneOffsetValue } from '../../../../../../utils/Timezones/Timezones';
import {
  HOURLY_DEFAULT_OPT,
  FREQUENCY_DEFAULT,
  DAILY_HOUR_DEFAULT,
} from '../../../../components/IngestionOverrideForm/utils/constants';

/**
 * Initialize all form defaults for ingestionOverrideForm
 * @returns object
 */
export const initIngestionSchedule = () => [
  {
    id: null,
    override: false,
    frequency: FREQUENCY_DEFAULT,
    time: DAILY_HOUR_DEFAULT,
    timezone: getTimezoneOffsetValue(),
    schedule: HOURLY_DEFAULT_OPT,
  },
];
